// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: "AIzaSyDQUDjd0g33Coc96d1cPp9Dm9KwnZgtACE",
    authDomain: "liketat-3df0a.firebaseapp.com",
    databaseURL: "https://liketat-3df0a.firebaseio.com",
    projectId: "liketat-3df0a",
    storageBucket: "liketat-3df0a.appspot.com",
    messagingSenderId: "717414075300",
    appId: "1:717414075300:web:c7def24ff04d8ad4"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
